import React from "react"
import { connect } from "react-redux";
import styled from "@emotion/styled"
import ShortDescriptionRow from "./emoji/short_description_row"
import ShortDescriptionContainer from "./emoji/short_description_container"
import VariantSections from "./emoji/variant_sections"
import CopyEmoji from "./emoji/copy_emoji"
import { GatsbyImage } from "gatsby-plugin-image"

class EmojiPageComponent extends React.PureComponent {
  render() {
    const { data } = this.props;
    return (
      <>
        { data.emoji.siblings.length === 0 &&
          <EmojiPageStyle className="section">
            <div className="section_inner">
              {
                data.emoji.mainImage && <GatsbyImage image={data.emoji.mainImage.image.childImageSharp.gatsbyImageData} loading="eager" alt="" />
              }
              {
                data.emoji.description && data.emoji.description.split("\n").map((p, i)=>{
                  return <p key={`description_${i}`}>{p}</p>
                })
              }
              <CopyEmoji emoji={data.emoji} {...this.props}/>
              { data.emoji.tags && data.emoji.tags.length > 0 && <div>
              <strong>Keywords:</strong> {data.emoji.tags.map(w => {
                return w.trim();
              }).join(', ')}
              </div> }
              <div><strong>Codepoints:</strong> { data.emoji.codepoints }</div>
              <div><strong>Introduced:</strong>{` `}
              { data.emoji.unicodeVersion.date } 
              {` `}
              in Unicode version { data.emoji.unicodeVersion.version } (Emoji version {data.emoji.emojiVersion.version})</div>            
            </div>
          </EmojiPageStyle>  
        }
        { data.emoji.siblings.length > 0 &&
          <EmojiPageStyle className="section">
            <div className="section_inner">
              <p className="sibling_description">{data.emoji.description}</p>            
            </div>
          </EmojiPageStyle>  
        }
        <VariantSections emoji={data.emoji} {...this.props} />
        <RelatedStyle className="section">
          <div className="section_inner">
            <h3>Related emoji</h3>
            <ShortDescriptionContainer>
              {data.emoji.related.map((emoji, i) => {
                 return <ShortDescriptionRow 
                  key={emoji.id}
                  emoji={emoji} 
                  show_description={true}
                  parentKey={emoji.id}
                  />
               })}
            </ShortDescriptionContainer>
          </div>
        </RelatedStyle>
      </>
    )
  }
}

const EmojiPageStyle = styled("div")`
margin: 0 0 1.25em;
p.sibling_description {
  margin-bottom:0;
}
`

const RelatedStyle = styled("div")`
background: #6DBDC9;
`

export default connect(state => ({
  lastCopy: state.lastCopy
}), dispatch => {
  return {
		copy: (copyData) => dispatch({ type: `COPY`, copy: copyData }),
	}
})(EmojiPageComponent);